import React from "react";

function SideNav({ isNavOpen, onCloseNav }) {
  const handleNavClick = (event, targetId) => {
    event.preventDefault();
    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
    onCloseNav();
  };

  return (
    <>
      <div
        className={`nav-backdrop ${isNavOpen ? "is-visible" : ""}`}
        onClick={onCloseNav}
      />
      
      <nav
        className={`side-menu ${isNavOpen ? "is-open" : ""}`}
        aria-hidden={!isNavOpen}
      >
        {/* Close button nella sidebar */}
        <button 
          className="menu-close-btn" 
          onClick={onCloseNav}
          aria-label="Chiudi menu"
        >
          <span></span>
          <span></span>
        </button>

        <div className="menu-inner">
          <ul className="menu-links">
            <li>
              <a href="#home" onClick={(e) => handleNavClick(e, "home")}>
                Home
              </a>
            </li>
            <li>
              <a href="#bio" onClick={(e) => handleNavClick(e, "bio")}>
                Bio
              </a>
            </li>
            <li>
              <a href="#progetti" onClick={(e) => handleNavClick(e, "progetti")}>
                Progetti Accademici
              </a>
            </li>
            <li>
              <a href="#musica" onClick={(e) => handleNavClick(e, "musica")}>
                Musica & Eventi
              </a>
            </li>
          </ul>

          <div className="menu-footer">
            <a href="mailto:enricocuomo9@gmail.com" className="menu-email">
              enricocuomo9@gmail.com
            </a>
            <div className="menu-socials">
              <a
                href="https://www.linkedin.com/in/enrico-cuomo"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <span className="menu-divider">·</span>
              <a href="https://drive.google.com/drive/folders/1oKtXlNWBxqUTaFiKMNMJDgyDG4rOAcVZ?usp=sharing" target="_blank" rel="noopener noreferrer">
                CV
              </a>
            </div>
          </div>
        </div>

        {/* Forme decorative gialle nel menu */}
        <div className="menu-shapes">
          <div className="menu-shape menu-shape-1"></div>
          <div className="menu-shape menu-shape-2"></div>
        </div>
      </nav>
    </>
  );
}

export default SideNav;
